import { Label } from "../../ui/label";
import { Input } from "../../ui/input";
import AdvancedSection from "./AdvancedSection";

export default function FijoConfig({ config, onChange }) {
  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
        <p className="text-sm text-gray-700">
          Prima fija por plan. El precio único se toma de la tabla <strong>Precios Base</strong> del plan
          (fila con <code>plan_id</code> + <code>Activo</code>). Configura el precio en el tab "Precios Base (UF)".
        </p>
      </div>
      <AdvancedSection>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label className="text-xs text-gray-500">Precio base — Tabla</Label>
            <Input value={config?.precioBase?.tabla || ""} onChange={(e) => onChange("precioBase.tabla", e.target.value)} placeholder="precios_base" />
          </div>
          <div>
            <Label className="text-xs text-gray-500">Precio base — Campo Resultado</Label>
            <Input value={config?.precioBase?.campoResultado || ""} onChange={(e) => onChange("precioBase.campoResultado", e.target.value)} placeholder="precio_uf" />
          </div>
        </div>
      </AdvancedSection>
    </div>
  );
}
